import React from 'react'
import Navbar from '../Navbar/Navbar';
import Product from './Product';
import Signup from '../../auth/Signup';

const HomePage = () => {
    return (
        <div>
            <Navbar >
                <Product ></Product>

            </Navbar>
        </div>
    )
}

export default HomePage;